import { BrowserRouter } from 'react-router-dom';

import { AppRoutes } from './app.routes';
import { AuthRoutes } from './auth.routes';
import { FirstAccessRoutes } from './first-access.routes';
import { AppLayout } from '../layouts/AppLayout';
import {EnvironmentBanner} from "../components/common/EnvironmentBanner";
import {useAppContext} from "../contexts/AppContext";

export function Routes({ userToken, isFirstAccess }) {
  const { dadosUsuario } = useAppContext();

  return (
      <>
        {/*<BrowserRouter>*/}
          {userToken ?
            (isFirstAccess
              ? <FirstAccessRoutes />
              : (
                  <>
                      <EnvironmentBanner isSempher={dadosUsuario?.isSempher} />

                      {/*<AppLayout>*/}
                      <AppRoutes />
                      {/*</AppLayout>*/}
                  </>
              )
            )
            : <AuthRoutes />
          }
        {/*</BrowserRouter>*/}
      </>
  )
}